module.exports = __webpack_public_path__ + "static/media/itemsgreen-new.51885403.svg";